import { useMemo } from 'react';

import { UploaderValue } from '@xsolla/ui-uploader';

export const useImageUploaderValue = (imageUrl?: string): UploaderValue | null => {
  return useMemo(() => {
    if (!imageUrl) {
      return null;
    }

    return {
      url: imageUrl,
      filename: ''
    };
  }, [imageUrl]);
};
